import { render, staticRenderFns } from "./download.vue?vue&type=template&id=1a2925f2&scoped=true&"
import script from "./download.vue?vue&type=script&lang=js&"
export * from "./download.vue?vue&type=script&lang=js&"
import style1 from "./download.vue?vue&type=style&index=1&id=1a2925f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2925f2",
  null
  
)

export default component.exports